import SchemaField from 'react-jsonschema-form/lib/components/fields/SchemaField';
import OneOf from './OneOf';
import SchemaAsFunction from './SchemaAsFunction';

export default SchemaField |> SchemaAsFunction |> OneOf;
